import n from "./index47.js";
import { DIRECTION as a, isString as l } from "./index125.js";
import u from "./index127.js";
class c {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(t), this._value || (this._isRawInput = !1), new n();
  }
  nearestInputPos(e, t) {
    t === void 0 && (t = a.NONE);
    const i = 0, s = this._value.length;
    switch (t) {
      case a.LEFT:
      case a.FORCE_LEFT:
        return i;
      case a.NONE:
      case a.RIGHT:
      case a.FORCE_RIGHT:
      default:
        return s;
    }
  }
  totalInputPositions(e, t) {
    return e === void 0 && (e = 0), t === void 0 && (t = this._value.length), this._isRawInput ? t - e : 0;
  }
  extractInput(e, t, i) {
    return e === void 0 && (e = 0), t === void 0 && (t = this._value.length), i === void 0 && (i = {}), i.raw && this._isRawInput && this._value.slice(e, t) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, t) {
    if (t === void 0 && (t = {}), this.isFilled)
      return new n();
    const i = this.eager === !0 || this.eager === "append", r = this.char === e && (this.isUnmasking || t.input || t.raw) && (!t.raw || !i) && !t.tail, h = new n({
      inserted: this.char,
      rawInserted: r ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = r && (t.raw || t.input), h;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new n();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new u("");
  }
  appendTail(e) {
    return l(e) && (e = new u(String(e))), e.appendTo(this);
  }
  append(e, t, i) {
    const s = this._appendChar(e[0], t);
    return i != null && (s.tailShift += this.appendTail(i).tailShift), s;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
export {
  c as default
};
